var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreActionsMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 22,
    viewBox: "0 0 7 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.46154,
    cy: 2.53846,
    r: 2.53846,
    transform: "rotate(90 3.46154 2.53846)",
    fill: "#A7BBCF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.53771,
    cy: 10.5385,
    r: 2.53846,
    transform: "rotate(90 3.53771 10.5385)",
    fill: "#A7BBCF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.53771,
    cy: 18.5385,
    r: 2.53846,
    transform: "rotate(90 3.53771 18.5385)",
    fill: "#A7BBCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreActionsMobile);
export default __webpack_public_path__ + "static/media/more-actions-mobile.4c97d3c7e35d63008e40ebb7135661e3.svg";
export { ForwardRef as ReactComponent };